module.exports = __webpack_public_path__ + "static/media/Awaiting.10701386.svg";